// extracted by mini-css-extract-plugin
export default {"sort-icons":"SortArrows_sort-icons__3WKQo"};